/**
 * Selectors for tutorials
 */

import { TUTORIAL_KEY } from './reducers';

/**
 * Selector to get the state for a particular tutorial
 */
export const getTutorialState = (state, id) => state.getIn([TUTORIAL_KEY, id]);
